import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchFilterFilter } from '@app/search/search-api.model';
import { WindowLayoutService } from '@dg/shared-services';
import { SubscriberBaseDirective } from '@app/shared/components/subscriber-base/subscriber-base.directive';

@Component({
  selector: 'dgx-search-mobile-filters-modal',
  templateUrl: './search-mobile-filters-modal.component.html',
  styleUrls: ['./search-mobile-filters-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchMobileFiltersModalComponent
  extends SubscriberBaseDirective
  implements OnInit
{
  @Input() public isLoading: boolean;
  @Input() public filters: SearchFilterFilter[];

  // In the mobile filter view, we don't submit filters with each change
  // Instead, we cache the filter state and return it when the user submits
  private filterState: SearchFilterFilter[];

  constructor(
    private activeModal: NgbActiveModal,
    private windowLayoutService: WindowLayoutService
  ) {
    super();
  }

  public ngOnInit() {
    // The sidebar filter is available at sizes larger than TeenieBear
    // so let's close the window if the user resizes to a larger size
    this.windowLayoutService
      .registerMediaListener(
        [this.windowLayoutService.dgBreakpoints.TeenieBear],
        false
      )
      .pipe(this.takeUntilDestroyed())
      .subscribe(({ matches }) => matches || this.activeModal.dismiss());
  }

  // Update the cache with the latest filters state
  public onFiltersChange(updatedFilterState: SearchFilterFilter[]) {
    this.filterState = updatedFilterState;
  }

  public onSubmit() {
    this.activeModal.close(this.filterState);
  }
}
